import { Star } from "lucide-react";
import { SITE } from "@/lib/site";

const testimonials = [
  {
    name: "Marcus Reed",
    role: "Entrepreneur, Houston",
    quote:
      "Their team rebuilt my financial strategy from the ground up. I finally feel in control of both protection and growth.",
    img: SITE.images.avatar1,
  },
  {
    name: "Camille Park",
    role: "Family of Four, Austin",
    quote:
      "Calm, premium, and refreshingly clear. They explained cash value in fifteen minutes — no jargon, no pressure.",
  },
  {
    name: "Devon Hayes",
    role: "Agent in Training",
    quote:
      "The mentorship is unreal. I came in with zero experience and built a real business in months.",
  },
];

export default function TestimonialsSection() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl reveal">
          <div className="text-[11px] uppercase tracking-[0.28em] text-rolex-light mb-6">
            Stories
          </div>
          <h2 className="font-serif font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
            Trusted by families &{" "}
            <span className="italic text-rolex-light">future agents.</span>
          </h2>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="reveal relative rounded-3xl glass p-10 flex flex-col gap-6 hover:border-rolex/30 transition-all duration-500"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex gap-1">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star
                    key={k}
                    className="h-3.5 w-3.5 fill-rolex-light text-rolex-light"
                  />
                ))}
              </div>
              <blockquote className="font-serif text-2xl leading-snug text-white text-balance">
                "{t.quote}"
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-rolex to-black border border-rolex/40 overflow-hidden">
                  {t.img ? (
                    <img
                      src={t.img}
                      alt=""
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center text-rolex-light text-sm font-serif">
                      {t.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                  )}
                </div>
                <div>
                  <div className="text-white text-sm font-medium">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-500 uppercase tracking-[0.2em] mt-0.5">
                    {t.role}
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
